module.exports = __webpack_public_path__ + "static/Bilde_AC-c73f9c20928062a75e353b4680d038ee.png";